/*eslint-disable */

import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import {
  bus
} from '@/main';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');


Vue.component('multiselect', Multiselect)

export default {
  name: 'shared-briefcase',
  components: {Multiselect},
  props: ['sharedBriefcaseINFO'],
  data () {
    return {
      submitted:false,
      userList:{},
      userListResults:[], 
      options:[],
      name:'',
      sentUserData:[],
      users:[],
      sharedBriefcaseId:''
    }
  },
  computed: {

  },
  mounted () {
    this.getAllUserListMethod()
    this.name = this.sharedBriefcaseINFO.name
    this.sharedBriefcaseId = this.sharedBriefcaseINFO.id
  },
  methods: {
    getAllUserListMethod() {
     this.$store.dispatch('isConditionalListOfAllUsersFun').then((res) => {
       this.userList = res.data.data
       if(this.userList != undefined){
         this.userListResults = this.userList
         for(var i = 0; i < this.userListResults.length; i++){
           this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
         }
       }
     }).catch((err)=>{})
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.users.push(tag) 
    },
    customLabel ({ email, first_name, last_name }) {
      return `${first_name} ${last_name} - ${email}`
    },
    sharedBriefcaseMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          for(var i = 0; i < this.users.length; i++){
            this.sentUserData.push(this.users[i].id)
          }
          var data = {
            briefcase_folder:this.sharedBriefcaseId,
            user:this.sentUserData
          }
          this.$store.dispatch('shareBriefcaseDetailsWithUserAction', data)
            .then((res) => { 
              toast.success(res.data.msg);
              this.submitted =  false
              this.sharedBriefcasePopupDisabledFun()
            }).catch((err) => {
              toast.error(err.data.msg);
              this.submitted =  false
            })
          return;
        }
      })
    },
    sharedBriefcasePopupDisabledFun(){
      $('body').removeClass('body_right_scroll_remove')
      bus.$emit('sharedBriefcasePopupStateBus', false);
      this.sentUserData = []
      this.sharedBriefcaseId = ''
      this.name = ''
    }
  }
}